import {Component, Input, OnDestroy} from "@angular/core";
import {Async} from "@helper/async.decorator";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {BackendService} from "@core/services/backend.service";

@Component({
	selector: "app-refund-cancel-refund-popup",
	templateUrl: "./refund-cancel-refund-popup.component.html",
	styleUrls: ["./refund-cancel-refund-popup.component.scss"],
})
export class RefundCancelRefundPopupComponent implements OnDestroy {
	@Async() public close$ = new Subject<boolean>();
	@Input() public paymentId;
	@Input() public refundRequest;

	private unsubscribe$$ = new Subject<void>();

	constructor(private backendService: BackendService,) {
		console.log(this.paymentId, this.refundRequest);
	}

	public cancelRefund() {
		this.backendService.payments.cancelRefund.put$(this.paymentId, this.refundRequest)
			.pipe(takeUntil(this.unsubscribe$$))
			.subscribe({
				next: (res) => {
					console.log(res);
					this.close$.next(true);
				}
			});
	}

	public ngOnDestroy(): void {
		this.unsubscribe$$.next();
		this.unsubscribe$$.complete();
	}
}
